module.exports = __webpack_public_path__ + "img/baiyunshan.9c2a0ef9.jpg";